import { ComponentStylesDefinitions } from "@zoovu/runner-browser-api";
import RootContainerStyle from "./root-container-style";
import QuestionHeadStyle from "./components/question-head-style";
import QuestionTopStyle from "./components/question-top-style";
import PagesNavigationStyle from "./components/pages-navigation-style";
import PageSelectorSliderStyle from "./components/page-selector-slider-style";
import AdvisorStyle from "./components/advisor-view-style";
import QuestionValidationMessageStyle from "./components/question-validation-message-style";
import AdviceStyle from "./components/advice-style";
import ProductRecommendationStyle from "./components/product-recommendation-style";
import TopProductStyle from "./components/top-product-style";
import BreadcrumbsStyle from "./components/breadcrumbs-style";
import StartOverButtonStyle from "./components/start-over-button-style";
import AdviceNavigationStyle from "./components/advice-navigation-style";
import RadioButtonAnswerStyle from "./components/radio-button-answer-style";
import CheckboxAnswerStyle from "./components/checkbox-answer-style";
import DropDownQuestionStyle from "./components/drop-down-question-style";
import SliderQuestionStyle from "./components/slider-question-style";
import ChoiceQuestionStyle from "./components/choice-question-style";
import ChoiceAnswerStyle from "./components/choice-answer-style";

const styleList: ComponentStylesDefinitions = {
  RootContainerStyle,
  QuestionHeadStyle,
  QuestionTopStyle,
  PagesNavigationStyle,
  PageSelectorSliderStyle,
  AdvisorStyle,
  QuestionValidationMessageStyle,
  AdviceStyle,
  ProductRecommendationStyle,
  TopProductStyle,
  BreadcrumbsStyle,
  StartOverButtonStyle,
  AdviceNavigationStyle,
  RadioButtonAnswerStyle,
  CheckboxAnswerStyle,
  DropDownQuestionStyle,
  SliderQuestionStyle,
  ChoiceQuestionStyle,
  ChoiceAnswerStyle
};

export default styleList;
